import introduction from './introduction/index'
import { chapter1sub1 } from './chapter1/index'
import { chapter1sub2 } from './chapter1/index'

const books = {
  // 书籍的基本信息
  basic: {
    title: '机械制图与AutoCAD',
    cover: require('@/assets/images/books/book1/book-cover.png'),
    judge: '主审 胡震',
    editor: '主编 邵永山 韦兰花',
  },
  // 书籍的目录 需要与内容对应以获取定位
  catalogue: [
    // 绪论
    {
      key: 'introduction',
      name: '绪论',
    },
    {
      key: 'chapter1',
      name: '模块一 机械制图的基本知识与技能',
      children: [
        {
          key: 'chapter1sub1',
          firstChildKey: 'section2',
          name: '任务一 认识与机械制图有关的国家标准',
        },
        {
          key: 'chapter1sub2',
          firstChildKey: 'section3',
          name: '任务二 绘制平面图形',
        },
      ],
    },
  ],
  // 图书内容
  content: {
    introduction: introduction,
    chapter1sub1,
    chapter1sub2
  },
  // 图书下载文件
  fileDownload: [],
}
export default books